import { css, cx } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import {
  Dialog as AriaDialog,
  DialogProps as AriaDialogProps,
} from "react-aria-components";

import { mq } from "../../utils";

export interface DialogProps extends AriaDialogProps {
  width?: string | number;
}

export function _Dialog(props: DialogProps) {
  const { width = 480, ...dialogProps } = props;

  const className = useMemo(() => {
    return cx("react-aria-Dialog", css(mq({ width: [undefined, width] })));
  }, [width]);

  return <AriaDialog {...mergeProps(dialogProps, { className })} />;
}
